import type { Technique } from '../types';
import { ASCII_MOSAIC_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, toSVG, type AsciiMosaicState } from './render';

export const asciiMosaic: Technique<AsciiMosaicState> = {
  id: 'ascii-mosaic',
  name: 'Zeichen-Mosaik',
  category: 'deconstruction',
  description: 'Baut die Textmaske aus kleineren Zeichen auf, sortiert nach Dichte.',
  params: ASCII_MOSAIC_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  toSVG,
  elementCount,
};
